const mutations = {
  SET_SEARCH_TEXT(state, payload) {
    state.search_text = payload.search_text;
  },
};
export default mutations;
